<template>
<AdminPanelEGiftsList />
</template>

<script>
import AdminPanelEGiftsList from '../components/AdminPanelEGiftsList.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEGiftsList
    },
    methods: {},
    mounted() {}
}
</script>
